// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;The Lord is loving to everyone&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and his mercy is over all his creatures.<br> </p> </div></div>";
// Exports
module.exports = code;